import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { Collapse, Nav } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import AppContext from '../../context/Context';
import NavbarVerticalMenuItem from './NavbarVerticalMenuItem';
import { metaBackends } from '../../../../meta';

function CollapseItems({ section }) {
  const { pathname } = useLocation();

  const openCollapse = (childrens) => {
    const checkLink = (children) => {
      if (children.resource && metaBackends[children.resource]
        && metaBackends[children.resource].frontendURL === pathname) {
        return true;
      }
      return (
        Object.prototype.hasOwnProperty.call(children, 'children')
        && children.children.some(checkLink)
      );
    };
    return childrens.some(checkLink);
  };

  const [open, setOpen] = useState(openCollapse(section.children));

  return (
    <Nav.Item as="li">
      <Nav.Link
        onClick={() => {
          setOpen(!open);
        }}
        className={classNames('dropdown-indicator cursor-pointer', {
          'text-500': !metaBackends[section.children],
        })}
        aria-expanded={open}
      >
        <NavbarVerticalMenuItem section={section} />
      </Nav.Link>
      <Collapse in={open}>
        <Nav className="flex-column nav" as="ul">
          <NavbarVerticalMenu sections={section.children} />
        </Nav>
      </Collapse>
    </Nav.Item>
  );
}

CollapseItems.propTypes = {
  section: PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    icon: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })).isRequired,
  }).isRequired,
};

function NavbarVerticalMenu({ sections }) {
  const {
    config: { showBurgerMenu },
    setConfig,
  } = useContext(AppContext);

  const handleNavItemClick = () => {
    if (showBurgerMenu) {
      setConfig('showBurgerMenu', !showBurgerMenu);
    }
  };
  return sections.map((section) => {
    if (!section.children) {
      const hasMd = !!metaBackends[section.resource];
      // eslint-disable-next-line no-nested-ternary

      const calcUrl = metaBackends[section.resource] ? metaBackends[section.resource].frontendURL : '#';
      const frontendURL = section.frontendURL ? section.frontendURL : calcUrl;
      return (
        <Nav.Item as="li" key={section.name} onClick={handleNavItemClick}>
          <NavLink
            to={frontendURL}
            className={({ isActive }) => classNames(
              'nav-link',
              { active: isActive && hasMd, disabled: !hasMd },
            )}
          >
            <NavbarVerticalMenuItem section={section} />
          </NavLink>
        </Nav.Item>
      );
    }

    return <CollapseItems section={section} key={section.name} />;
  });
}

NavbarVerticalMenu.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    resource: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      resource: PropTypes.string,
    })),
  }))
    .isRequired,
};

export default NavbarVerticalMenu;
